<template>
  <div class="avatar">
    <div class="avatr-title">
        鹏昌科技
    </div>
    <div class="user-message">
        <img src="../../assets/image/touxaing.jpg" style="height: 50px;width: 50px;border-radius: 30px; margin: 10px;" alt="">
        <div style="font-size: 20px;" v-if="userInfo">
            {{ userInfo.username }}
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            userInfo: {}
        }
    },
    created(){
        this.userInfo = JSON.parse(localStorage.getItem("userinfo"))
    },
    methods: {

    }
}
</script>

<style lang="less" scoped>
    .avatar {
        width: 100%;
        // height: 200px;
    }
    .avatr-title {
        height: 60px;
        text-align: center;
        line-height: 60px;
        // display: flex;
        // justify-content: center;
        // align-content: center;
        color: #ffffff;
        font-size: 28px;
    }
    .user-message {
        line-height: 70px;
        display: flex;
        // justify-content: center;
        align-content: center;
        color: #ffffff;
        font-size: 24px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/avatar.vue